import { render, staticRenderFns } from "./AssProgramDetail.vue?vue&type=template&id=1b93fd9e&scoped=true"
import script from "./AssProgramDetail.vue?vue&type=script&lang=js"
export * from "./AssProgramDetail.vue?vue&type=script&lang=js"
import style0 from "./AssProgramDetail.vue?vue&type=style&index=0&id=1b93fd9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93fd9e",
  null
  
)

export default component.exports